import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import AnalysisProgress from './AnalysisProgress';
import AnalysisList from './AnalysisList';
import AnalysisActions from './AnalysisActions';
import { cancelAnalysisAsync, clearAnalysis } from '../../../../../redux/analysis/Actions';
import { compose } from 'redux';
import { connect } from 'react-redux';


class Analysis extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux Props
        analysis: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, analysis } =this.props;
        return (
            <div className={classes.root}>
                <AnalysisProgress />
                {
                    analysis.status !== 'failed' && <>
                        <div className={classes.border} />
                        <AnalysisList />
                        <div className={classes.border} />
                        <AnalysisActions />
                    </>
                }
            </div>
        );
    }
}

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        },
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    },
    border: {
        height: '2px',
        backgroundColor: theme.palette.background.border
    }
});

const mapStateToProps = state => {
    return {
        analysis: state.analysis.analysis
    };
};

export default compose(
    connect(mapStateToProps, null),
    withStyles(style)
)(Analysis);